/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import {
  Form, Input, Radio, Row, Col,
} from 'antd';
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
import { BILL_ADDRESS_LIST, getFirstRegion } from './const';
import DownLogo from '../../assets/down_icon.svg';
import classes from './BillAdress.module.css';

export default function BillAddress({ countryData, stateData }) {
  const form = Form.useFormInstance();

  const [country, setCountry] = useState('');
  const [region, setRegion] = useState('');

  const handleChangeRegion = (val) => {
    form.setFieldValue('other_state', val);
    setRegion(val);
  };

  const handleChangeCountry = (val) => {
    form.setFieldValue('other_country', val);
    setCountry(val);
    const firstRegion = getFirstRegion(CountryRegionData, val);
    handleChangeRegion(firstRegion);
  };
  useEffect(() => {
    handleChangeCountry(countryData);
    handleChangeRegion(stateData);
  }, [countryData, stateData]);
  return (
    <div>
      <Form.Item noStyle className={classes.radio_group} name="billType">
        <Radio.Group>
          {BILL_ADDRESS_LIST.map(({
            value, label,
          }) => (
            <div className={classes.radio} key={value}>
              <Radio value={value}>
                <div className={classes.radio_title}>
                  {label}
                </div>
              </Radio>
            </div>
          ))}
        </Radio.Group>
      </Form.Item>
      <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.billType !== currentValues.billType} style={{ marginBottom: 0 }}>
        {({ getFieldValue }) => {
          const billType = getFieldValue('billType');
          if (billType === 2) {
            return (
              <div>
                <Form.Item label="Street" name="other_street">
                  <Input />
                </Form.Item>
                <Form.Item label="Apartment, suite, etc. (optional)" name="other_apartment">
                  <Input />
                </Form.Item>
                <Form.Item label="City" name="other_city">
                  <Input />
                </Form.Item>
                <Row gutter={16}>
                  <Col span="8">
                    <Form.Item label="Country/region" name="other_country">
                      <CountryDropdown
                        value={country}
                        onChange={(val) => handleChangeCountry(val)}
                        id="billCountry"
                        name="billCountry"
                        valueType="short"
                        classes="clear_style"
                      />
                    </Form.Item>
                    <img src={DownLogo} alt="" className="country_region_down_icon" />
                  </Col>
                  <Col span={8}>
                    <Form.Item label="State" name="other_state">
                      <RegionDropdown
                        showDefaultOption={false}
                        country={country}
                        value={region}
                        onChange={(val) => handleChangeRegion(val)}
                        id="billState"
                        name="billState"
                        countryValueType="short"
                        classes="clear_style"
                      />
                    </Form.Item>
                    <img src={DownLogo} alt="" className="country_region_down_icon" />
                  </Col>
                  <Col span={8}>

                    <Form.Item label="Postal code" name="other_postalCode">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>

              </div>
            );
          }
          return null;
        }}
      </Form.Item>
    </div>
  );
}
